<template>
  <div class="vx-row">
    <div class="vx-col w-full">
      <vx-card :title="'COMPANY HOLIDAYS'" class="">
        <template slot="actions">
          <vs-button v-can="'edit-holidays-setting'" @click.stop="onClickAdd" icon-pack="feather" icon="icon-plus" class="mr-4"  color="primary" type="filled">create</vs-button>
        </template>
        <div id="company-holidays" class="vx-row">
          <div class="vx-col w-full">

            <vs-table stripe sort class="mt-8" :data="company_holidays">
              <template slot="thead">
                <vs-th sort-key="date" width="15%">DATE</vs-th>
                <vs-th width="65%">DETAILS</vs-th>
                <vs-th width="10%">ACTION</vs-th>
              </template>

              <template slot-scope="{data}">
                <vs-tr :key="indextr" v-for="(tr, indextr) in data">

                  <vs-td :data="data[indextr].date">
                    {{ data[indextr].date }}
                  </vs-td>

                  <vs-td :data="data[indextr].name">
                    {{ data[indextr].name }}
                  </vs-td>

                  <vs-td :data="data[indextr].name">
                    <div class="vx-row justify-start" v-can="'edit-holidays-setting'">
                      <vx-tooltip text="Remove" position="left">
                        <vs-button @click.stop="openConfirm(data[indextr].id)" class="ml-3"
                                   size="small" color="danger" type="border" icon-pack="feather" icon="icon-trash-2"></vs-button>
                      </vx-tooltip>
                      <vx-tooltip text="Update" position="left">
                        <vs-button @click="onClickUpdate(data[indextr].id)"  class="ml-3"
                                   size="small" color="warning" type="border" icon-pack="feather" icon="icon-edit-2"></vs-button>
                      </vx-tooltip>
                    </div>
                  </vs-td>

                </vs-tr>
              </template>

            </vs-table>

          </div>
        </div>
      </vx-card>

      <vx-card title="ALL CLOSED HOLIDAYS" class="mt-8">
          <div class="vx-row" id="public-holidays">
            <div class="vx-col w-1/2" v-for="item in holidays" :key="item.year">
                  <vs-table stripe sort class="mt-8" :data="item.dates">
                        <template slot="header">
                            <h3 class="ml-2mb-2">{{ item.year }}</h3>
                        </template>
                    <template slot="thead">
                      <vs-th sort-key="date" width="20%">DATE</vs-th>
                      <vs-th width="80%">DETAILS</vs-th>
                    </template>

                    <template slot-scope="{data}">
                      <vs-tr :key="indextr" v-for="(tr, indextr) in data">

                        <vs-td :data="data[indextr].date">
                          {{ data[indextr].date }}
                        </vs-td>

                        <vs-td :data="data[indextr].name">
                          {{ data[indextr].name }}
                        </vs-td>
                      </vs-tr>
                    </template>

                  </vs-table>

            </div>
          </div>
      </vx-card>
    </div>
    <add-new-company-holiday-pop-up ref="addNewCompanyHolidayPopUp"/>
  </div>
</template>

<script>
  import {RepositoryFactory} from '@/repository/RepositoryFactory';
  import AddNewCompanyHolidayPopUp from "@/components/popups/settings/holidays/AddNewCompanyHolidayPopUp";

  const HolidayRepository = RepositoryFactory.get('holiday');
  export default {
    name: "CurrencySettings",
    data() {
      return {
        holidays: [],
        company_holidays: [],
      }
    },
    components: {
      AddNewCompanyHolidayPopUp
    },
    methods: {
      async refreshData() {
        await this.fetchCompanyHolidays()
        await this.fetchAllHolidays()
      },
      async fetchAllHolidays() {
        await this.$vs.loading({
        container: '#public-holidays',
        scale: 0.45
      })
        const {data} =  (await HolidayRepository.getListOfHolidays()).data
        this.holidays = data.filter(holiday => holiday.year === new Date().getFullYear())
        this.$vs.loading.close('#public-holidays > .con-vs-loading')
      },
      async fetchCompanyHolidays() {
        await this.$vs.loading({
        container: '#company-holidays',
        scale: 0.45
      })
        const {data} =  (await HolidayRepository.getListOfCompanyHolidays()).data
        this.company_holidays = data
        this.$vs.loading.close('#company-holidays > .con-vs-loading')
      },
      async onClickAdd() {
        await this.$refs.addNewCompanyHolidayPopUp.openPopup()
      },
      async onClickUpdate(id) {
        await this.$refs.addNewCompanyHolidayPopUp.openPopup(id)
      },
      openConfirm(id) {
        this.$vs.dialog({
          type: 'confirm',
          color: 'danger',
          title: `Confirm`,
          text: 'Are you sure you want to delete this ?',
          accept: this.onClickDelete,
          parameters: [id]
        })
      },
      async onClickDelete(params) {
        try {
          await HolidayRepository.deleteCompanyHoliday(params[0])
          await this.fetchCompanyHolidays()
          await this.fetchAllHolidays()
        }catch (e) {
        }
      }
    },
    async mounted() {
      await this.fetchCompanyHolidays()
      await this.fetchAllHolidays()
    }
  }
</script>

<style scoped>

</style>
